// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__mszf7","label":"CategoryService_label__3Fbc9","location":"CategoryService_location__ZTz0P"};